module.exports = __webpack_public_path__ + "static/requests-content-1-bf568362fcc356abdf342eee0aef8c8d.png";